// Shared helpers for converting a browser URL/location into Jelly.Current_Path.
// We intentionally ignore window.location.hash (used for modals) and rely on pathname+search.

Jelly.URL.Normalize_Pathname = function(Pathname)
{
	var Normalized = Pathname || "";

	// Strip leading/trailing slashes (but do not touch the query string).
	Normalized = Normalized.replace(/^\/*/, "");
	Normalized = Normalized.replace(/\/*$/, "");

	return Normalized;
};

Jelly.URL.Build_Path = function(Pathname, Search)
{
	var Path = Jelly.URL.Normalize_Pathname(Pathname);
	var Query = Search || "";

	var Combined = Path + Query;

	// If no path is specified, set the default path.
	if (Combined == "")
		Combined = Jelly.Default_Path;

	return Combined;
};

Jelly.URL.Get_Path_From_Location = function()
{
	return Jelly.URL.Build_Path(window.location.pathname, window.location.search);
};

Jelly.URL.Get_Path_From_URL = function(URL)
{
	if (!URL)
		return Jelly.URL.Get_Path_From_Location();

	// Ignore hash fragments entirely (hash is reserved for modals).
	var Hash_Position = URL.indexOf("#");
	if (Hash_Position > -1)
		URL = URL.substring(0, Hash_Position);

	// If it's an absolute URL (or root-relative), let the browser parse it.
	if (Jelly.URL.Is_Absolute(URL) || URL.charAt(0) == "/")
	{
		var Anchor = document.createElement("a");
		Anchor.href = URL;
		return Jelly.URL.Build_Path(Anchor.pathname, Anchor.search);
	}

	// Otherwise treat it as root-relative (Force_URL historically assumed this anyway).
	var Relative_Anchor = document.createElement("a");
	Relative_Anchor.href = "/" + URL;
	return Jelly.URL.Build_Path(Relative_Anchor.pathname, Relative_Anchor.search);
};


